import classNames from 'classnames';
import React from 'react';

import Icon, { IconName } from '@/components/Icon/Icon';
import Button from '@/components/OldButton/OldButton';
import { Contentful } from '@/contentful/types';

import useStyles from './ComparisonTable.style';

export interface ComparisonTableListItem extends Contentful {
  fields: {
    icon: string;
    text: string;
  };
}

export interface ComparisonTableList extends Contentful {
  fields: {
    title: string;
    items: ComparisonTableListItem[];
  };
}

export interface ComparisonTableContent extends Contentful {
  fields: {
    title: string;
    subtitle: string;
    benefitList: ComparisonTableList[];
    ctaButtonText: string;
    ctaButtonUrl: string;
    isFavorite: boolean;
  };
}

interface Props {
  content: ComparisonTableContent;
}

/**
 * @deprecated V2 component
 */
export default function ComparisonTable({ content }: Props) {
  const { classes } = useStyles();
  const {
    title,
    subtitle,
    benefitList,
    ctaButtonText,
    ctaButtonUrl,
    isFavorite,
  } = content.fields;

  const renderComparisonTableList = (
    comparisonTableList: ComparisonTableList
  ): React.JSX.Element => {
    return (
      <>
        <div className={classes.benefitContainer}>
          <div className={classes.benefitTitle}>
            {comparisonTableList?.fields?.title}
          </div>
          {comparisonTableList?.fields?.items.map((item, index) => (
            <div className={classes.benefit} key={index}>
              <div className={classes.benefitIcon}>
                <Icon name={item?.fields?.icon as IconName} />
              </div>
              <div className={classes.benefitName}>{item?.fields?.text}</div>
            </div>
          ))}
        </div>
      </>
    );
  };

  return (
    <div
      className={classNames([classes.table, isFavorite && classes.favorite])}
    >
      {isFavorite && <div className={classes.favoriteTag}>Most Popular</div>}
      <div className={classes.header}>
        <div className={classes.title}>{title}</div>
        <div className={classes.subtitle}>{subtitle}</div>
      </div>
      <div className={classes.benefits}>
        {benefitList.map((benefits, index) => (
          <React.Fragment key={index}>
            {renderComparisonTableList(benefits)}
          </React.Fragment>
        ))}
      </div>
      <div className={classes.cta}>
        <Button label={ctaButtonText} url={ctaButtonUrl} />
      </div>
    </div>
  );
}
